<div nz-row nzType="flex">
    <div nz-col nzSpan="6">
        <div class="formname">{{formTitle}}</div>
    </div>

    <div nz-col nzSpan="18" style="display: flex; justify-content: flex-end;">
        <form nz-form [nzLayout]="'inline'">
            <nz-form-item>
                <nz-radio-group name="radioValue" [(ngModel)]="radioValue"
                    (ngModelChange)="changeRadioButton($event,true)" nzButtonStyle="solid">
                    <label nz-radio-button nzValue="A">Today's</label>
                    <label nz-radio-button nzValue="B">Yesterday's</label>
                    <label nz-radio-button nzValue="C">Last 7 Days</label>
                    <label nz-radio-button nzValue="D">Last Month</label>
                    <label nz-radio-button nzValue="E">Current Month</label>
                </nz-radio-group>
            </nz-form-item>

            <nz-form-item>
                <button nz-button nzType="primary" style="margin-right: 0px;" (click)="importInExcel()"
                    [nzLoading]="loadprojectexcel"><i nz-icon nzType="file-excel" nzTheme="outline"></i></button>
            </nz-form-item>

            <nz-form-item style="margin-right: 0px;">
                <button nz-button [nzType]="isFilterApplied" (click)="showFilter()"><i nz-icon
                        nzType="filter"></i></button>
            </nz-form-item>

            <!-- <nz-form-item>
                <nz-input-group nzSearch [nzAddOnAfter]="suffixIconButton">
                    <input type="text" name="search" autocomplete="off" nz-input placeholder="Search by User"
                        [(ngModel)]="searchText" (keydown.enter)="onEnterGetAllEmployeeWiseHoursDetails()" />
                </nz-input-group>

                <ng-template #suffixIconButton>
                    <button nz-button name="button1" id="button1" nzType="primary"
                        (click)="getAllEmployeeWiseHoursDetails(true)" nzSearch><i nz-icon nzType="search"></i></button>
                </ng-template>
            </nz-form-item> -->
        </form>
    </div>
</div>

<div nz-row>
    <div nz-col nzSpan="24">
        <div class="filter {{filterClass}}">
            <div class="filter-box">
                <form nz-form>
                    <div nz-row nzGutter="16">
                        <div nz-col nzSpan="7">
                            <div nz-row>
                                <div nz-col nzSpan="24">
                                    <nz-form-label nzNoColon><b>Date</b></nz-form-label>

                                    <nz-input-group>
                                        <div nz-row>
                                            <div nz-col nzSpan="12">
                                                <nz-date-picker style="width: 100%;" nzFormat="dd/MM/yyyy"
                                                    name="startDate" (nzOnOpenChange)="startDateHandle($event)"
                                                    [(ngModel)]="START_DATE">
                                                </nz-date-picker>
                                            </div>

                                            <div nz-col nzSpan="12">
                                                <nz-date-picker #endDatePicker style="width: 100%;"
                                                    nzFormat="dd/MM/yyyy" name="endDate"
                                                    [nzDisabledDate]="disabledEndDate" [(ngModel)]="END_DATE">
                                                </nz-date-picker>
                                            </div>
                                        </div>
                                    </nz-input-group>
                                </div>

                                <!-- <div nz-col nzSpan="24">
                                    <nz-form-label nzNoColon><b>Actions</b></nz-form-label>

                                    <nz-input-group>
                                        <nz-radio-group name="radioValue" [(ngModel)]="radioValue"
                                            (ngModelChange)="changeRadioButton($event,false)" nzButtonStyle="solid">
                                            <label nz-radio-button nzValue="A">Today's</label>
                                            <label nz-radio-button nzValue="B">Yesterday's</label>
                                            <label nz-radio-button nzValue="C">Last 7 Days</label>
                                            <label nz-radio-button nzValue="D">Last Month</label>
                                            <label nz-radio-button nzValue="E">Current Month</label>
                                        </nz-radio-group>
                                    </nz-input-group>
                                </div> -->
                            </div>
                        </div>

                        <div nz-col nzSpan="17">
                            <nz-form-label nzNoColon><b>Users</b></nz-form-label>

                            <nz-input-group>
                                <nz-select style="width: 100%;" name="moduleAssigneeName" nzMaxTagCount="5"
                                    nzMode="multiple" nzShowSearch nzAllowClear [(ngModel)]="MODULE_ASSIGNEE_ID"
                                    nzPlaceHolder="Select Users">
                                    <nz-option nzCustomContent *ngFor="let assignee of newAssigneeList"
                                        [nzValue]="assignee.ID" [nzLabel]="assignee.NAME">
                                        <div>
                                            {{assignee.NAME}}
                                        </div>

                                        <div style="font-size: 12px; color: gray; text-align: right;">
                                            <span>~&nbsp;{{assignee.TASK_CATEGORY_NAME}}</span>
                                        </div>
                                    </nz-option>
                                </nz-select>
                            </nz-input-group>
                        </div>

                        <div nz-col nzSpan="7">
                            <nz-form-label nzNoColon><b>Project Type</b></nz-form-label>

                            <nz-input-group>
                                <nz-select style="width: 100%;" name="type" nzShowSearch nzAllowClear
                                    (ngModelChange)="onStatusChange($event)" nzPlaceHolder="Select Project Type"
                                    [(ngModel)]="TYPE">
                                    <nz-option nzLabel="Billable" nzValue="B"></nz-option>
                                    <nz-option nzLabel="Non Billable" nzValue="NB"></nz-option>
                                </nz-select>
                            </nz-input-group>
                        </div>

                        <div nz-col nzSpan="17">
                            <nz-form-label nzNoColon><b>Project</b></nz-form-label>

                            <nz-input-group>
                                <nz-select name="projectName" style="width: 100%;" nzMode="multiple" nzMaxTagCount="5"
                                    nzShowSearch nzAllowClear style="width: 100%" [(ngModel)]="projectID"
                                    nzPlaceHolder="Select Project">
                                    <nz-option *ngFor="let project of projectList" [nzValue]="project.ID"
                                        [nzLabel]="project.NAME"></nz-option>
                                </nz-select>
                            </nz-input-group>
                        </div>

                        <div nz-col nzSpan="24">
                            <nz-form-label nzNoColon><b>Actions</b></nz-form-label><br />

                            <nz-button-group nzSize="default">
                                <button style="margin-right: 10px;" nz-button nzType="primary"
                                    (click)="getAllEmployeeWiseHoursDetails(true)" nzJustify="end">
                                    <i nz-icon nzType="filter"></i>Apply Filter
                                </button>
                                <button nz-button nzType="primary" (click)="clearFilter()">
                                    <i nz-icon nzType="delete"></i>Clear Filter
                                </button>
                            </nz-button-group>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>

<div nz-row>
    <div nz-col nzSpan="24">
        <nz-table class="my-scroll no-wrap1" nzBordered #table nzShowSizeChanger [nzFrontPagination]="false"
            [nzData]="projectData" [nzLoading]="loadingRecords" [nzTotal]="totalRecords" [(nzPageIndex)]="pageIndex"
            [(nzPageSize)]="pageSize" (nzQueryParams)="sort($event)" [nzScroll]="{ y: '400px' }"
            style="white-space: pre-line;">

            <thead>
                <tr>
                    <!-- <th nzLeft nzWidth="200px" *ngFor="let column of columns" nzColumnKey="{{column[0]}}"
                        [nzSortFn]="true"><b>{{column[1]}}</b></th> -->
                    <th nzLeft nzWidth="135px" [nzSortFn]="true" style="text-align: center;"><b>Employee ID</b></th>

                    <th nzLeft nzWidth="150px"[nzSortFn]="true" style="text-align: center;"><b>Employee Name</b></th>

                    <th nzLeft nzWidth="100px"><b>Total Time</b></th>
                    <th nzWidth="100px" *ngFor="let day of days"><b>{{day | date: 'dd-MMM-yyyy'}}</b></th>
                </tr>
            </thead>

            <tbody>
                <tr *ngFor="let data of table.data" style="cursor: pointer;">
                    <!-- <td nzLeft nzWidth="200px" *ngFor="let column of columns">{{data[column[0]]}}</td> -->
                    <td nzLeft nzWidth="100px" style="text-align: center;">{{data.EMPLOYEE_ID}}</td>
                    <td nzLeft nzWidth="150px"><span
    nz-tooltip
    [nzTooltipTitle]="data.NAME?.length > 16 ? data.NAME : null"
    style="display:block; white-space:nowrap; overflow:hidden; text-overflow:ellipsis;">
    {{
      data.NAME?.length > 16
        ? (data.NAME | slice:0:16) + '...'
        : data.NAME
    }}
  </span></td>
                    <td nzLeft nzWidth="100px">{{data.TOTAL_SECONDS | secondToHours}}</td>
                    <td nzWidth="100px" *ngFor="let day of days">{{data[day] | secondToHours}}</td>
                </tr>
            </tbody>
        </nz-table>
    </div>
</div>